import { FaWhatsapp } from "react-icons/fa";

const WhatsAppFloatingButton = () => {
  const phoneNumber = "917888974447";
  const message = "Hello, I'm interested in your services!";
  const waLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center">
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        className="animate-float bg-green-500 text-white p-5 md:p-6 lg:p-4 rounded-full shadow-lg hover:bg-green-600 transition-transform hover:scale-105"
      >
        <FaWhatsapp className="text-3xl md:text-3xl lg:text-2xl" />
      </a>


    </div>
  );
};

export default WhatsAppFloatingButton;
